/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { gql } from '@apollo/client';
import { useLingui } from '@lingui/react';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

// We need to define the valid currency translations so the numberFormat doesn't throw errors.
const currencies = {
  $: 'USD',
  USD: 'USD',
  US$: 'USD',
  '€': 'EUR',
  EUR: 'EUR',
  '£': 'GBP',
  GBP: 'GBP',
  CA$: 'CAD',
  CAD: 'CAD',
  default: 'EUR',
};

/**
 *
 * @param {object} props
 * @param {object} props.pricing
 * @param {'symbol' | 'code' | 'name'} [props.currencyDisplay]
 * @param {boolean} [props.useGrouping]
 * @returns
 */
export default function ProductPrice({
  pricing,
  currencyDisplay,
  useGrouping,
  ...rest
}) {
  const { i18n } = useLingui();
  if (!hasContent(pricing)) return null;
  const priceFormat = {
    style: 'currency',
    currency: currencies[pricing.currencyCode] || currencies.default,
    currencyDisplay,
    useGrouping,
  };
  return <span {...rest}>{i18n.number(pricing.price, priceFormat)}</span>;
}

ProductPrice.hasContent = hasContent;
function hasContent(pricing) {
  if (pricing?.price != null) return true;
  return false;
}

export const fragment = graphql`
  fragment bb_ProductPrice on Bottlebooks_ProductPrice {
    price
    currencyCode: currency(format: RAW)
    priceType
    bottleSize
  }
`;

ProductPrice.fragment = gql`
  fragment ProductPrice on ProductPrice {
    price
    currencyCode: currency(format: RAW)
    priceType
    bottleSize
  }
`;
